<template>
    <div class="admin">
        <AdminHeader />
        <div class="ad_contain">
            <div id="ad_side" class='nav'>
                <AdminNav />
            </div>
            <div id="ad_display">
                <router-view />
            </div>
        </div>
    </div>
</template>


<script>

import AdminHeader from '@/components/AdminHeader.vue';
import AdminNav from '@/components/AdminNav.vue';


export default {
    name: 'AdminLayout',
    components: {
        AdminNav,
        AdminHeader
    }
}
</script>
<style>

.ad_contain {
    min-height: 100vh;
    display: flex;
    background-color: rgb(233, 233, 233);
}

#ad_display {
    flex: 1;
    padding: 20px;
    text-align: left;
}
</style>